import React from 'react';
import { useRecoilValue } from 'recoil';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { collectionFiltersState } from '../../../../../../utils/recoil/collection';
import FilterService from '../../../../../../services/FilterService';

export const FiltersSummary = ({ filters, resetLabel }) => {
  const collectionFilters = useRecoilValue(collectionFiltersState);

  const summary = () =>
    filters?.items.map((filter) =>
      filter?.inputs.map((input) => {
        if (Object.keys(collectionFilters).includes(input.name)) {
          const onClick = (value) => {
            FilterService.removeFilter(input.name, value);
            // if (typeof collectionFilters[input.name] === 'string') {
            //   const cpy = {
            //     ...collectionFilters,
            //   };
            //   delete cpy[input.name];
            //   setFilters(cpy);
            // } else {
            //   setFilters({
            //     ...collectionFilters,
            //     [input.name]:
            //       collectionFilters[input.name] &&
            //       collectionFilters[input.name].filter((i) => i !== value),
            //   });
            // }
          };

          const filterValues = input.values
            .filter((value) => {
              return collectionFilters[input.name]?.includes(value.value);
            })
            .map((value) => (
              <div className='mb-2'>
                <Badge
                  color={{ classname: 'primary' }}
                  size='base'
                  type='outlined'
                  dotColor={value.color && value.color}
                  label={{ text: value.label?.text }}
                  button={{
                    onClick: () => {
                      onClick(value.value);
                    },
                    icon: {
                      iconKey: 'MdCancel',
                      color: { classname: 'gray-600' },
                    },
                  }}
                />
              </div>
            ));
          return filterValues;
        } else {
          return null;
        }
      })
    );

  return (
    <div className='flex w-full flex-wrap space-x-2 my-6'>
      {summary()}
      <button
        type='button'
        onClick={() => {
          FilterService.reset();
        }}
        className='hover:underline cursor-pointer'>
        <Label {...resetLabel} />
      </button>
    </div>
  );
};
